export default "__VITE_ASSET__BmbzDum4__"